export default class Osoba {
	OsobaFullName: string = "";

	public constructor(init?: Partial<Osoba>) {
		Object.assign(this, init);
	}
}